import { h } from "hyperapp";

export const contactRenderer = ({ contacts }) => {
  if (contacts.length === 0) {
    return "";
  }

  const [contact] = contacts;

  const email = contact.email ? (
    <a href={`mailto:${contact.email}`}>{contact.email}</a>
  ) : (
    ""
  );

  return (
    <span>
      <a href={`tel:${contact.phone}`}>{contact.phone}</a>
      {email && <br />}
      {email}
    </span>
  );
};
